<div>
    <table mat-table [dataSource]="messages" class="sms-table">
        <ng-container matColumnDef="message">
            <th mat-header-cell *matHeaderCellDef style="display: none;"></th>
            <td mat-cell *matCellDef="let message">
                <app-sms-row [message]="message"></app-sms-row>
            </td>
        </ng-container>
        <tr class="hide-header" mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
</div>